import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
// import VueSplide from "@splidejs/vue-splide";
// import "@splidejs/vue-splide/css";

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  // VueSplide,

  render: function (h) {
    return h(App);
  },
}).$mount("#app");
